package com.taocent.simple.compose.component.richtext.core.platform

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

interface RichTextPlatformAdapter {
    val supportsSystemContextMenu: Boolean
    val supportsRichClipboard: Boolean
    val supportsImeComposition: Boolean
    val requiresCollapsedCursorContextToolbarToggle: Boolean

    fun Modifier.suppressNativeContextMenu(onContextMenuRequested: () -> Unit): Modifier
}

/**
 * 把 [RichTextPlatformAdapter] 作为显式参数(避免 with{...} 作用域在 Composable
 * lambda 中的类型推断问题)的扩展 — 供 [RichTextTextFieldCore] 等 Composable 内部使用。
 */
fun Modifier.suppressNativeContextMenu(
    platformAdapter: RichTextPlatformAdapter,
    onContextMenuRequested: () -> Unit,
): Modifier = with(platformAdapter) {
    this@suppressNativeContextMenu.suppressNativeContextMenu(onContextMenuRequested)
}

@Composable
expect fun rememberRichTextPlatformAdapter(): RichTextPlatformAdapter
